import React, { useState } from 'react';

const ReturnModal = ({
    onClose,
    onConfirm,
    title = 'ส่งกลับให้แก้ไข Return to user',
    subtitle = 'ระบุสิ่งที่ต้องการให้ user แก้ไขในแบบฟอร์ม',
    label = 'ส่งที่ให้แก้ไข',
    warning = 'ข้อมูลนี้จะถูกส่งไปยัง User ที่ส่งคำขอมา',
    submitLabel = 'Submit',
    showWarning = true,
}) => {
    const [note, setNote] = useState('');

    const handleSubmit = () => {
        if (!note.trim()) return;
        onConfirm(note.trim());
    };

    return (
        <div className="return-modal-overlay" onClick={onClose}>
            <div className="return-modal" onClick={(e) => e.stopPropagation()}>
                <h2 className="return-modal__title">{title}</h2>
                <p className="return-modal__subtitle">{subtitle}</p>

                <div className="return-modal__field">
                    <label className="return-modal__label">{label}</label>
                    <textarea
                        className="return-modal__textarea"
                        placeholder="Type your message here"
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                        rows={4}
                    />
                    {showWarning && (
                        <div className="return-modal__warning" style={{ marginTop: 12 }}>
                            <i className="ri-error-warning-fill" />
                            <span>{warning}</span>
                        </div>
                    )}
                </div>

                <div className="return-modal__footer">
                    <button className="return-modal__btn return-modal__btn--cancel" onClick={onClose}>
                        Cancel
                    </button>
                    <button
                        className="return-modal__btn return-modal__btn--submit"
                        onClick={handleSubmit}
                        disabled={!note.trim()}
                    >
                        {submitLabel}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReturnModal;